import { cx } from '@linaria/core';
import { useAppContext, stringifyPublisher } from '@provider/app-context';
import { PublisherLogo } from '@ui/kit/icons';
import { logo, textWrapper, wrapper } from './atom.header.style.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

function PrintHeader(props) {
  const publisher = useAppContext(state => state.publisher);
  const product = useAppContext(state => state.product);
  const course = useAppContext(state => state.course);
  const title = `${stringifyPublisher(publisher)}s fagportaler`;
  return /*#__PURE__*/jsxs("header", {
    className: cx(wrapper, props.position),
    children: [/*#__PURE__*/jsx(PublisherLogo, {
      className: logo,
      small: true
    }), /*#__PURE__*/jsxs("div", {
      className: textWrapper,
      children: [/*#__PURE__*/jsx("b", {
        children: title
      }), product ? /*#__PURE__*/jsxs(Fragment, {
        children: [" ", "|", " ", /*#__PURE__*/jsxs("span", {
          children: [" ", product.title, " ", product.gradesLabel, " ", product.classLabel, " |"]
        }), /*#__PURE__*/jsxs("span", {
          children: [" ", "Arbejdsark", course?.title ? /*#__PURE__*/jsxs(Fragment, {
            children: [" ", "til ", /*#__PURE__*/jsx("b", {
              children: course.title
            })]
          }) : ""]
        })]
      }) : ""]
    })]
  });
}

export { PrintHeader };
//# sourceMappingURL=atom.header.js.map
